
export default {
    props: {
        /**
         * The number of reports
         */
        count: {
            type: Number,
            default: 0,
        },
        /**
         * A vue route object
         */
        route: {
            type: Object,
            required: true,
        },
        /**
         * Text for the link
         */
        text: {
            type: String,
            required: true,
        },
    },
};

